import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personnel-relieving',
  templateUrl: './personnel-relieving.component.html',
  styleUrls: ['./personnel-relieving.component.css']
})
export class PersonnelRelievingComponent implements OnInit {
  title="Personnel Relieving";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/personnel-details/Personnel-Relievings/personnel-relieving/personnel-relieving.component.ts